import React from 'react';

import i18n from '@translations/i18n';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ArticleIcon from '@mui/icons-material/Article';
import EventIcon from '@mui/icons-material/Event';
import SchoolIcon from '@mui/icons-material/School';
import ApartmentIcon from '@mui/icons-material/Apartment';
import HelpIcon from '@mui/icons-material/Help';
import StoreIcon from '@mui/icons-material/Store';
import ForumIcon from '@mui/icons-material/Forum';
import SecurityIcon from '@mui/icons-material/Security';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ChatIcon from '@mui/icons-material/Chat';
import { IModuleMenuItem } from './components/ModuleMenuItem/interfaces';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import LockPersonIcon from '@mui/icons-material/LockPerson';

import { Location } from 'react-router';
import { PERMISSIONS } from '@auth/permissions';

export const modules: IModuleMenuItem[] = [
  {
    id: 'member-portal',
    title: i18n.t('modules:options.member-portal.title'),
    subTitle: i18n.t('modules:options.member-portal.subTitle'),
    icon: <PersonIcon />,
    link: '/',
    inProduction: true,
  },
  {
    id: 'my-profile',
    title: i18n.t('modules:options.my-profile.title'),
    subTitle: i18n.t('modules:options.my-profile.subTitle'),
    icon: <PermContactCalendarIcon />,
    link: '/profile',
    inProduction: true,
  },
  {
    id: 'news',
    title: i18n.t('modules:options.news.title'),
    subTitle: i18n.t('modules:options.news.subTitle'),
    icon: <ArticleIcon />,
    link: '/manage/news',
    inProduction: true,
    permission: PERMISSIONS.newsItems.view,
  },
  {
    id: 'member-management',
    title: i18n.t('modules:options.member-management.title'),
    subTitle: i18n.t('modules:options.member-management.subTitle'),
    icon: <GroupIcon />,
    link: '/manage/members',
    inProduction: true,
    permission: PERMISSIONS.members.view,
  },
  {
    id: 'roles-and-permissions',
    title: i18n.t('modules:options.roles-and-permissions.title'),
    subTitle: i18n.t('modules:options.roles-and-permissions.subTitle'),
    icon: <LockPersonIcon />,
    link: '/manage/roles-and-permissions',
    inProduction: true,
    permission: PERMISSIONS.roles.view,
  },
  {
    id: 'competition-management',
    title: i18n.t('modules:options.competition-management.title'),
    subTitle: i18n.t('modules:options.competition-management.subTitle'),
    icon: <EmojiEventsIcon />,
    link: '/manage/competitions',
    inProduction: true,
    permission: [
      PERMISSIONS.competitions.view,
      PERMISSIONS.competitions.disciplines.view,
    ],
  },
  {
    id: 'photo-management',
    title: i18n.t('modules:options.photo-management.title'),
    subTitle: i18n.t('modules:options.photo-management.subTitle'),
    icon: <PhotoLibraryIcon />,
  },
  {
    id: 'weapon-management',
    title: i18n.t('modules:options.weapon-management.title'),
    subTitle: i18n.t('modules:options.weapon-management.subTitle'),
    icon: <SecurityIcon />,
  },
  {
    id: 'attendance',
    title: i18n.t('modules:options.attendance.title'),
    subTitle: i18n.t('modules:options.attendance.subTitle'),
    icon: <PersonPinIcon />,
  },
  {
    id: 'schedule',
    title: i18n.t('modules:options.schedule.title'),
    subTitle: i18n.t('modules:options.schedule.subTitle'),
    icon: <CalendarTodayIcon />,
  },
  {
    id: 'events',
    title: i18n.t('modules:options.events.title'),
    subTitle: i18n.t('modules:options.events.subTitle'),
    icon: <EventIcon />,
  },
  {
    id: 'training-courses',
    title: i18n.t('modules:options.training-courses.title'),
    subTitle: i18n.t('modules:options.training-courses.subTitle'),
    icon: <SchoolIcon />,
  },
  {
    id: 'association',
    title: i18n.t('modules:options.association.title'),
    subTitle: i18n.t('modules:options.association.subTitle'),
    icon: <ApartmentIcon />,
    link: '/manage/association',
    inProduction: true,
    permission: [
      PERMISSIONS.association.about.view,
      PERMISSIONS.association.instructions.view,
      PERMISSIONS.association.boardMembers.view,
      PERMISSIONS.association.rulesAndRegulationsPage.view,
      PERMISSIONS.association.weaponGroups.view,
    ],
  },
  {
    id: 'administration',
    title: i18n.t('modules:options.administration.title'),
    subTitle: i18n.t('modules:options.administration.subTitle'),
    icon: <AssessmentIcon />,
    link: '/administratie',
  },
  {
    id: 'message-center',
    title: i18n.t('modules:options.message-center.title'),
    subTitle: i18n.t('modules:options.message-center.subTitle'),
    icon: <ChatIcon />,
    link: '/berichtencentrum',
  },
  {
    id: 'faq',
    title: i18n.t('modules:options.faq.title'),
    subTitle: i18n.t('modules:options.faq.subTitle'),
    icon: <HelpIcon />,
  },
  {
    id: 'marketplace',
    title: i18n.t('modules:options.marketplace.title'),
    subTitle: i18n.t('modules:options.marketplace.subTitle'),
    icon: <StoreIcon />,
  },
  {
    id: 'forum',
    title: i18n.t('modules:options.forum.title'),
    subTitle: i18n.t('modules:options.forum.subTitle'),
    icon: <ForumIcon />,
  },
];

export const getActiveModuleBasedOnLocation = (
  location: Location
): IModuleMenuItem => {
  const active = modules.find((module) => {
    return (
      module.link &&
      module.link !== '/' &&
      location.pathname.startsWith(module.link)
    );
  });

  if (active) {
    return active;
  }

  return modules[0];
};
